import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={9}
    fill="currentColor"
    viewBox="0 0 12 9"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 6.78 1.687 4.467a.664.664 0 1 0-.94.94l2.786 2.786c.26.26.68.26.94 0l7.054-7.053a.664.664 0 1 0-.94-.94z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCheck;
